<div class="bg-main" [ngStyle]="{'background-image': 'url(' + bgImageUrl + ')'}">

  <nav class="header-wrapper">
    
    <div class="header-left">
      <div class="welcome-box">
        <p><b>Welcome:</b> {{ cname }}</p>
        <p *ngIf="IsSalesRep"><b>Customer:</b> {{ selectedCustomerName }}</p>
        <p *ngIf="!IsMobile"><b>Credit Limit:</b> {{ credit | currency }}</p>
        <p *ngIf="!IsMobile">
          <b>Balance Outstanding:</b>
          <a [routerLink]="['/pages/orderHistory']" [queryParams]="{ tab: 3 }">
            {{ balance | currency }}
          </a>
        </p>
      </div>
    </div>

    <div class="header-center">
      <img [src]="logoPath" class="logo"/>
    </div>

    <div class="header-right">
      <app-dropdown></app-dropdown>
    </div>

  </nav>

  <div class="action-bar" *ngIf="IsSalesRep">
    <button class="btn-approval" [routerLink]="['/pages/approval']">
      Orders Waiting For Approval
    </button>
  </div>

</div>
